import { useQuery } from '@tanstack/react-query'
import { toast } from '@telavita-core/react-design-kit'
import { AxiosResponse } from 'axios'
import { useOptimisticUpdate } from 'hooks/useOptimisticUpdate'

import {
  updateNotificationPreferences,
  IPhoneNotificationData,
  NotificationTypeEnum
} from 'services/me/preferences'
import { fetchPreferences, MePreferencesData } from 'services/me/preferences/service'
import { ME_PREFERENCES } from 'settings/_reactQueryConstants'

const toastInstance = (type: 'success' | 'error', text: string) => toast({
  type,
  text,
  position: 'top-right',
  autoClose: 3000,
  closeOnClick: true,
})

export const usePhoneNotificationsService = (): IPhoneNotificationData => {
  const { data, isError, isFetchedAfterMount } = useQuery({
    queryKey: [ME_PREFERENCES],
    queryFn: fetchPreferences,
    select: (prefs) => prefs?.schedule_notification_type,
    retry: false,
    refetchOnWindowFocus: false,
  })

  const { mutate: updatePhoneNotification } = useOptimisticUpdate<
    NotificationTypeEnum,
    MePreferencesData
  >({
    mutationFn: updateNotificationPreferences,
    queryKey: [ME_PREFERENCES],
    updater: (old, newValue) => ({
      ...(old || {} as MePreferencesData),
      schedule_notification_type: newValue,
    }),
    onErrorActionCallback: () => {
      toastInstance('error', 'Erro ao atualizar preferências de notificação')
    },
    onSuccessActionCallback: () => {
      toastInstance('success', 'Preferências de notificação atualizadas com sucesso')
    }
  })

  if (isError) {
    toastInstance('error', 'Erro ao carregar as preferências de notificações')
  }

  if (isFetchedAfterMount && data === null) {
    updateNotificationPreferences(NotificationTypeEnum.SMS)
  }

  return {
    data: data || NotificationTypeEnum.SMS,
    updatePhoneNotification
  }
}
